"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.removeAssetVerificationArtifacts = exports.addAssetVerificationArtifacts = void 0;
const lodash = __importStar(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils_1 = require("../dbNodes/utils");
const helpers_1 = require("./helpers");
const { cloneDeep } = lodash;
const generateNewSlug = (assignedLoanTapeSlug, newPartialSlug) => {
    // assignedLoanTapeSlug is guaranteed to be unique for the document
    // so we can just replace the assignedLoanTape with newPartialSlug
    if (assignedLoanTapeSlug.toLowerCase().includes('assignedloantape')) {
        return assignedLoanTapeSlug.replace(/assignedLoanTape/gi, newPartialSlug);
    }
    return `${assignedLoanTapeSlug}-${newPartialSlug}`;
};
const createTape = ({ creditFacilitySlug, loanProductSlug, artifactDocumentId, assignedLoanTapeSlug, }) => {
    const documentVerificationReportSlug = generateNewSlug(assignedLoanTapeSlug, 'documentVerificationTape');
    const verificationTape = {
        id: (0, uuid_1.v4)(),
        type: 'receivableDocumentationVerificationReport',
        artifactSlug: documentVerificationReportSlug,
        configuration: {},
        loanProductSlug,
        creditFacilitySlug,
        artifactDocumentId,
        externalFilename: null,
    };
    return verificationTape;
};
// this adds synthetic record for asset verification.
// this final synthetic node goes after assignedLoanTape, and has
// creditFacilitySlug + loanProductSlug copied from
// assignedLoanTape.
//
//     * Before *
// +----------------------+           +----------------------+
// |  assignedLoanTape    +---------->|  whatever            |
// +----------------------+           +----------------------+
//
//     * After *
// +----------------------+           +----------------------+
// |  assignedLoanTape    +---------->|  whatever            |
// +----------------------+---+       +----------------------+
//                            |
//                            |
//                            |       +---------------------------------------------+
//                            +------>|  receivableDocumentationVerificationReport  |
//                                    +---------------------------------------------+
//
const addAssetVerificationArtifacts = (dbGraph) => {
    const dataTapeDependencies = cloneDeep(dbGraph.dataTapeDependencies);
    const dataTapes = cloneDeep(dbGraph.dataTapes);
    // find receivableInvoice nodes. These nodes decide
    // if the pipeline should run asset verification or not.
    const receivableInvoiceTapes = (0, utils_1.filterReceivableInvoiceTapes)({
        dataTapes,
    });
    const assignedLoanTapes = (0, utils_1.filterAssignedLoanTapes)({ dataTapes });
    receivableInvoiceTapes.forEach((receivableInvoiceTape) => {
        // get locanProductSlug and creditFacilitySlug from its configuration
        const { loanProductSlug, creditFacilitySlug, artifactDocumentId, } = receivableInvoiceTape;
        (0, common_1.finleyAssert)(loanProductSlug, `addAssetVerificationArtifacts: loanProductSlug must be defined for ${receivableInvoiceTape.artifactSlug}`);
        (0, common_1.finleyAssert)(creditFacilitySlug, `addAssetVerificationArtifacts: creditFacilitySlug must be defined for ${receivableInvoiceTape.artifactSlug}`);
        // find assignedLoanTape corresponding to this receivableInvoiceTape
        const assignedLoanTape = assignedLoanTapes.find((tape) => {
            return (tape.loanProductSlug === loanProductSlug &&
                tape.creditFacilitySlug === creditFacilitySlug);
        });
        (0, common_1.finleyAssert)(assignedLoanTape, `addAssetVerificationArtifacts: assignedLoanTape was not found for ${loanProductSlug} and ${creditFacilitySlug}`);
        // add verification tape after assigned loan tape.
        // this new node is a final node.
        const verificationTape = createTape({
            loanProductSlug,
            creditFacilitySlug,
            artifactDocumentId,
            assignedLoanTapeSlug: assignedLoanTape.artifactSlug,
        });
        dataTapes.push(verificationTape);
        dataTapeDependencies.push({
            inputArtifactId: assignedLoanTape.id,
            outputArtifactId: verificationTape.id,
        });
    });
    return { dataTapeDependencies, dataTapes };
};
exports.addAssetVerificationArtifacts = addAssetVerificationArtifacts;
// removes all receivableDocumentationVerificationReport nodes
// and any dependencies that point to them.
// basically reverse of addAssetVerificationArtifacts above.
const removeAssetVerificationArtifacts = (dbGraph) => (0, helpers_1.removeNodesAndIncidentEdges)(cloneDeep(dbGraph), (0, utils_1.filterReceivableDocumentationVerificationReportTapes)(dbGraph).map(({ id }) => id));
exports.removeAssetVerificationArtifacts = removeAssetVerificationArtifacts;
exports.syntheticProcess = {
    toDb: exports.addAssetVerificationArtifacts,
    fromDb: exports.removeAssetVerificationArtifacts,
};
//# sourceMappingURL=assetVerification.js.map